;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputTextAreaController', InputTextAreaController)

  /* @ngInject */
  function InputTextAreaController ($scope) {
    $scope.onChange = function (newValue) {
      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }
  }
})()
